import i18n from '@/helpers/i18n'
import { Consts } from '@/helpers/consts'

export const EducationLevelList = {
  data() {
    return {
      educationLevelList: [
        { text: i18n.instance().t('scholarity-level-under-12', this.language), id: Consts.EDUCATION_LEVEL_LESS_THAN_12 },
        { text: i18n.instance().t('scholarity-level-12', this.language), id: Consts.EDUCATION_LEVEL_MORE_THAN_12 },
        { text: i18n.instance().t('scholarity-level-13', this.language), id: Consts.EDUCATION_LEVEL_MORE_THAN_13 },
        { text: i18n.instance().t('scholarity-level-14', this.language), id: Consts.EDUCATION_LEVEL_MORE_THAN_14 },
        { text: i18n.instance().t('scholarity-level-15', this.language), id: Consts.EDUCATION_LEVEL_MORE_THAN_15 },
        { text: i18n.instance().t('scholarity-level-16', this.language), id: Consts.EDUCATION_LEVEL_MORE_THAN_16 },
        { text: i18n.instance().t('scholarity-level-17-and-more', this.language), id: Consts.EDUCATION_LEVEL_MORE_THAN_17 }
      ]
    }
  },
  methods: {
    getEducationLevelFacetLabel: function(educationLevelFacet) {
      return `${this.educationLevelList.filter(x => x.id === educationLevelFacet.value.toString()).first().text} (${
        educationLevelFacet.count
      })`
    },
    getEducationLevelLabelById: function(id) {
      return this.educationLevelList.filter(x => x.id === id).first().text
    },
    getEducationLevelByFieldOfStudyId: function(id) {
      return this.educationLevelList.filter(x => x.id === id.toString()).first().text
    }
  }
}
